module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor246"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor247"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor248"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor249"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide2#toc6"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor250"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide2#toc6"
    }
  }, [_vm._v("The Holy Spirit in the First Three Gospels")])]), _vm._v(" "), _c('p', {
    staticClass: "BODYFLUSH"
  }, [_vm._v("Mark, probably the earliest of the gospels, has just six references to the Holy Spirit. Some argue that Mark has only three. Matthew has eleven references to the Spirit, and Luke has seventeen or eighteen, depending on the manuscript readings. Although Matthew and Luke include the part played by the Holy Spirit in the birth narratives, Mark and the threefold tradition of the synoptic gospels stress"), _c('em', {
    staticClass: "italic"
  }), _vm._v("the"), _c('em', {
    staticClass: "italic"
  }), _vm._v("action and person of the Spirit in the baptism of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(1) The Holy Spirit as Agent in the baptism of Jesus. In Mark 1:10-11, just as Jesus was coming out of the water, John the Baptist “saw the heavens torn apart and the Spirit descending like a dove on him. And a voice came from heaven, ‘You are my Son, the Beloved; with you I am well pleased.’ ” Matt. 3:16 is a close parallel, and Luke relates, “the Holy Spirit descended upon him in bodily form like a dove” (3:22). Luke also recounts the voice from heaven. The key theme here is that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the Holy Spirit anointed Jesus for")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("appointment to his messianic work and office. ")]), _vm._v("Through the centuries this theme has consistently featured as essential for understanding the person and work of the Holy Spirit, as well as of Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Some argue convincingly that in this special sense the gift of the Holy Spirit even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("precedes")]), _vm._v(" the coming of Jesus. Certainly the gift of the Spirit at the baptism of Jesus demonstrates the unity of Jesus Christ and the doctrine of the Holy Spirit."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-067-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-067"
    }
  }, [_vm._v("1")])])]), _vm._v(" At least one writer, Rogers, links the baptism of Jesus with an anticipation of the doctrine of the Trinity. He writes, “The baptism of Jesus is primarily to be understood as an intratrinitarian event . . . It is an event in which the Spirit bears witness to the love between the "), _c('a', {
    attrs: {
      "id": "_idTextAnchor251"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor252"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor253"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor254"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor255"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor256"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor257"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor258"
    }
  }), _vm._v("Father and the Son . . . The Father expresses his love (‘this is my Son, my beloved, with whom I am well pleased’).”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-066-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-066"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("A number of NT scholars would dissent from this interpretation, although Moltmann also took this Trinitarian approach earlier, and Pannenberg adopts this approach."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-065-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-065"
    }
  }, [_vm._v("3")])])]), _vm._v(" The very least that we can say is this: the Father, the Son, and the Holy Spirit all participate in this single purpose and event. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Father")]), _vm._v(" calls Jesus his beloved Son and commands that we hear him; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the Spirit")]), _vm._v(" descends upon Jesus, and anoints him for his messianic work; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus")]), _vm._v(" undergoes baptism, pleases his Father and accepts his will. Thereafter Jesus is clearly and explicitly led by the Holy Spirit. We discuss this passage further under Doctrine (Part II), when we consider the Spirit and the Trinity.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L3"
  }, [_vm._v("Many associate the baptism of Jesus with the promise of John the Baptist that Jesus “will baptize you with the Holy Spirit and fire” (Luke 3:16). Warrington interprets this correctly when he states, “the Spirit burns,” in the sense that he purifies and conveys holiness."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-064-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-064"
    }
  }, [_vm._v("4")])])]), _vm._v(" Many Pentecostals regard this verse, along with 1 Cor. 12:13, among those verses which point to “the baptism in the Holy Spirit.” We discuss this in Part III. Michael Welker comments, “The faith grounded by the Spirit through this public installation of the Christ and the hope grounded through the action of the Spirit, are concretized within specific spectra of experience and expectation.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-063-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-063"
    }
  }, [_vm._v("5")])])]), _vm._v(" The baptism of Jesus also looks back to Isaiah 11 and 42.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Craig Keener sees the baptism of Jesus as of critical importance for Matthew. He argues that Matt. 3:16, when the Spirit descended upon Jesus, is “critical to Matthew’s Gospel” because of its foundation for Jesus’ later mission; he observes, “12:28 (‘By the Spirit of God . . . I cast out demons’) is central in a large measure because Matthew defines Jesus’ Spirit-­empowerment contextually in terms of the Isaiah quotation.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-062-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-062"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(2) Many nineteenth-­century writers explicitly called this the messi"), _c('a', {
    attrs: {
      "id": "_idTextAnchor259"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor260"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor261"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor262"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor263"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor264"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor265"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor266"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor267"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor268"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor269"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor270"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor271"
    }
  }), _vm._v("anic anointing of Jesus. Smeaton rightly calls it “the anointing of Christ,” “the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("unction")]), _vm._v(" of the Spirit,” and the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("empowerment")]), _vm._v(" by the Spirit."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-061-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-061"
    }
  }, [_vm._v("7")])])]), _vm._v(" Luke adds “in bodily form” to show that it was an objective, visible experience, and not merely projected subjectively by the mind, as if it were purely a vision. But he qualifies this by adding that it was “like it,” i.e. not quite “bodily” in the sense of “physical,” but real, objective, public, and visible. The dove is not here a symbol of peace, but a symbol of the new creation, or a new era. Turner calls it “a metaphorical way of referring to the inception of a specific new activity.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-060-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-060"
    }
  }, [_vm._v("8")])])]), _vm._v(" Turner goes further in evaluating Luke’s theological assessment of the baptism of Jesus. He writes, “Jesus experiences a Spirit-­given new creation sonship with a depth . . . fundamentally changed by the Jordan experience.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-059-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-059"
    }
  }, [_vm._v("9")])])]), _vm._v(" All four Gospels regard the baptism of Jesus as a decisive event (cf. John 1:32-34). It signals the fulfilment of what Turner calls “Jesus’ installation as Son of God, king of Israel.” Hence this constitutes a public event.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L3"
  }, [_vm._v("(3) Matthew and Luke recount ways in which the initiative of the Holy Spirit featured in the birth narratives of Jesus. Matthew asserts, “She (Mary) was found to be with child from (Greek, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ek")]), _vm._v(") the Holy Spirit” (Matt. 1:18). Luke recounts the appearance to Mary of the angel Gabriel, who announces, “The Holy Spirit will come upon you, and the power of the Most High will overshadow you; therefore the child to be born will be holy; he will be called Son of God” (Luke 1:35). Luz rightly comments, “This refers to the creative intervention of God, and not to the Spirit as a second partner for Mary.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-058-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-058"
    }
  }, [_vm._v("10")])])]), _vm._v(" Welker calls this event “Jesus’ self-­abasement in solidarity with sinful human beings,” as indeed his baptism was."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-057-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-057"
    }
  }, [_vm._v("11")])])]), _vm._v(" He further comments, “Jesus "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demonstrates")]), _vm._v(" the power that he already has in relation to Satan by the very act of declining a spectacular moral or political seizure of power.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-056-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-056"
    }
  }, [_vm._v("12")])])]), _vm._v(" We discuss the Virgin Birth in greater detail in chapter 9, on Jesus and the Spirit in terms of Christian doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(4) The first three gospels tell us that immediately after the baptism "), _c('a', {
    attrs: {
      "id": "_idTextAnchor272"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor273"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor274"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor275"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor276"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor277"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor278"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor279"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor280"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor281"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor282"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor283"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor284"
    }
  }), _vm._v("of Jesus the Holy Spirit “drove” Jesus (Mark 1:12) into the wilderness to be tempted or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tested for his messianic vocation. ")]), _vm._v("Matthew uses the gentler form “led” (Matt. 4:1), while Luke says that Jesus went into the wilderness “full of the Holy Spirit” (Luke 4:1). The lesson for us is that sometimes, often even, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the Holy")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Spirit provokes conflict and testing. ")]), _vm._v("Would temptation have been real for Jesus? Yes, indeed! Robinson reminds us that if the pull of temptation had not been genuine, Jesus would not have been truly human."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-055-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-055"
    }
  }, [_vm._v("13")])])]), _vm._v(" So also Bishop Westcott argued, “Only One who is sinless has experienced the greatest intensity of temptation, for only such a person has not yielded before the last and greatest strain.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-054-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-054"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("But could Jesus have been tempted to do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("wrong?")]), _vm._v(" Each of the three classic messianic temptations were enticements to bring in the Kingdom, i.e. to achieve what was ultimately God’s will, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not in God’s way. ")]), _vm._v("To command that stones become bread (Matt. 4:3; Luke 4:3) was a way of impressing and winning followers or disciples by a spectacular miracle, but this was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" how God willed this to be achieved. It was not the way of the cross. Similarly Jesus was tempted to throw himself down from the high ground on which the Temple was built, into the deep valley of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gē Hinnom")]), _vm._v(", far below (Matt. 4:5-6; Luke 4:9). This, again, would win the crowds to his cause by a spectacular miracle. But it was not God’s will to win followers other than by the word of God and the cross. Third, Jesus was tempted to bring in the Kingdom of God by using the devil’s tools, i.e. to achieve it by brute force (Matt. 4:9; Luke 4:6-7). But Jesus asserted, “Worship the Lord your God, and serve "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only him.")]), _vm._v("” Jesus proved that he would obey only God, and he would obey him in every detail. He would use no shortcut to fulfil his Father’s will. All this came into the open at the specific instigation of the Holy Spirit. (Incidentally, the difference of chronological sequence in Matthew and Luke is due to the evangelists as narrators using “narrative time,” i.e. what best served the purposes of the narrative, rather than clock time).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The biblical accounts make it clear that temptations or testing was not limited to these three model examples. The devil left Jesus only “until an opportune time” (Luke 4:13). Similarly the anointing by the Holy Spirit continued throughout his messianic ministry. Thus, “Jesus, filled with the power of the Spirit, returned to Galilee” (Luke 4:14).")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L2"
  }, [_vm._v("(5) In his first synagogue sermon Jesus quoted from Isaiah, “The "), _c('a', {
    attrs: {
      "id": "_idTextAnchor285"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor286"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor287"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor288"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor289"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor290"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor291"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor292"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor293"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor294"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor295"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor296"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor297"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor298"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor299"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor300"
    }
  }), _vm._v("Spirit of the Lord is upon me, because he has anointed me to bring good news to the poor . . . release to the captives . . . the year of the Lord’s favor” (Luke 4:18-19, quoting mainly Isa. 61:1). The preaching of Jesus was in the power of the Holy Spirit."), _c('em', {
    staticClass: "italic"
  }), _vm._v("Lampe comments, “The reading of the prophecy and the announcement of its fulfilment in the mission of Jesus serve as a prologue to the whole of the rest of St. Luke’s work.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-053-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-053"
    }
  }, [_vm._v("15")])])]), _vm._v(" He regards preaching and prayer as the two outstanding gifts of the Spirit to Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("(6) The action of the Holy Spirit also concerns the “mighty works” of Jesus. These include exorcisms and miracles of healing. These phenomena stand in continuity with the rabbinic writings. Levison places these acts in the context of “doing good.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-052-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-052"
    }
  }, [_vm._v("16")])])]), _vm._v(" He is right to select the famous passage, “if it is by the Spirit of God that I cast out demons, then the kingdom of God has come to you” (Matt. 12:28). The important point here is that exorcisms are associated with the coming of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the Kingdom of God. ")]), _vm._v("Luke’s parallel has “finger of God” in place of “Spirit,” which may look back to Exod. 8:19, in relation to which Jesus brings the new exodus. Turner endorses the link with both the intertestamental writings and the new exodus theme."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-051-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-051"
    }
  }, [_vm._v("17")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Welker comments, “It is striking that in Jesus’ pre-­Easter activity, the demonic powers are not removed in one blow, but are ‘driven out’ in a multitude of individual, concrete actions of liberation.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-050-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-050"
    }
  }, [_vm._v("18")])])]), _vm._v(" The background, he says, is sober and realistic. Again, the presence of the Kingdom as part realised and part yet to come influences how exorcisms are viewed by the evangelists.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Luke includes the “rebuke” of the wind and the waves (Luke 8:22-25); the healing of the Gerasene demoniac (8:26-39); the restoration of Jairus’ daughter (8:40-42, 49-56); and the healing of the woman with a hemorrhage (8:43-48). There are many more. In this shorter volume, we have tried to avoid too many controversial issues. However, we find two distinct views about the importance of miracles and exorcisms for Jesus. Dunn regards Jesus as a “charismatic figure,” and Turner and Stronstad "), _c('a', {
    attrs: {
      "id": "_idTextAnchor301"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor302"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor303"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor304"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor305"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor306"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor307"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor308"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor309"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor310"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor311"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor312"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor313"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor314"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor315"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor316"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor317"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor318"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor319"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor320"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor321"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor322"
    }
  }), _vm._v("broadly support him."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-049-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-049"
    }
  }, [_vm._v("19")])])]), _vm._v(" On the other hand Barrett, Fison, Lampe, Levison, Warrington, and Congar tend to emphasize what they call the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kenōsis")]), _vm._v(", or “self-­emptying,” of the Spirit during the earthly ministry of Jesus, which places much less emphasis on the miracles and exorcisms.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L1"
  }, [_vm._v("Dunn calls Jesus “an ecstatic.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-048-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-048"
    }
  }, [_vm._v("20")])])]), _vm._v(" Stronstad stresses vocation and prophecy, and allows room for a more “charismatic” emphasis."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-047-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-047"
    }
  }, [_vm._v("21")])])]), _vm._v(" Barrett, however, considers the question, “Why do the Gospels say so little about the Spirit?” He concludes, “Jesus acted under the necessity of a divine constraint. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lack of glory and a cup of suffering were his Messianic vocation, and part of his poverty was the absence of all the signs of the spirit of God. ")]), _vm._v("They would have been inconsistent with the office of a humiliated Messiah.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-046-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-046"
    }
  }, [_vm._v("22")])])]), _vm._v(" In precisely the same way, Fison speaks of the “self-­effacement” of the Holy Spirit."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-045-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-045"
    }
  }, [_vm._v("23")])])]), _vm._v(" What Fison calls self-­effacement, Welker calls self-­abasement."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-044-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-044"
    }
  }, [_vm._v("24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Dunn can find support in Luke 4:18-19, and he insists rightly that Jesus relied on God in trust and on the Holy Spirit for his deeds of power. Yet Barrett and Fison are correct in their christology. Each side must be carefully qualified by the other. The exorcisms and miracles of Jesus are best understood as signs of the inbreaking of the Kingdom of God. They should not be regarded as “normal,” even if they always remain possible for almighty, sovereign God, on particular occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(7) One often puzzling saying is the pronouncement of Jesus about blasphemy against the Holy Spirit. Mark recounts the charge of some of the teachers of the law that Jesus was driving out demons by the prince of demons. Jesus replies, “People will be forgiven for their sins and whatever blasphemies they utter; but whoever blasphemes against the Holy Spirit can never have forgiveness, but is guilty of an eternal sin” (Mark 3:28-29). I wrote in our Doctrine Commission Report: “The saying stands as a warn"), _c('a', {
    attrs: {
      "id": "_idTextAnchor323"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor324"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor325"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor326"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor327"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor328"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor329"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor330"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor331"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor332"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor333"
    }
  }), _vm._v("ing against the wilful and deliberate manipulation of good and evil, when evil is called ‘good’ and good is called ‘evil.’ If a person were to manipulate all moral value and truth with such wilful cynicism, there is no way out of the vicious circle which has been erected.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-043-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-043"
    }
  }, [_vm._v("25")])])]), _vm._v(" How could repentance be possible, if evil has been redefined as good?")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("This is a serious saying of Jesus, but pastorally has needlessly troubled many enquirers. But it is a hypothetical warning to be understood "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not at all")]), _vm._v(" as a general statement, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("divorced from any context. ")]), _vm._v("It specifically addresses those who wilfully distort and reverse good and evil, undermining all moral values, thereby excluding all possibility of repentance. Pastorally, if anyone is worrying about this saying, this is a sign that the Holy Spirit is still working in their heart, and that they need not fear it.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY-L2"
  }, [_vm._v("In broader terms, the context relates to the overcoming of Satan by Jesus in the coming of the Kingdom of God. Mark 3:23 reads, “How can Satan cast out Satan?” and v. 27 continues, “no one can enter a strong man’s house and plunder his property without first tying up the strong man,” i.e. Jesus has begun the binding of Satan. Welker comments, “The superior power . . . overwhelms the demonic powers . . . Jesus’ action of driving out demons by the Spirit of God means that God’s rule has come.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-042-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-042"
    }
  }, [_vm._v("26")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(8) Dunn and others regard the special intimacy of Jesus with his Father as a prominent feature of the Holy Spirit’s activity. The special Aramaic word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Abba")]), _vm._v(" (“Father”) in Mark 14:36 is uniquely on the lips of Jesus, until Paul shows how it becomes the special privilege of all Christians to derive the same intimate word from Jesus by the Holy Spirit (Rom. 8:15-16; Gal. 4:6). In a wider sense God is the Father of all humankind as Creator and Provider (Deut. 32:6; Mal. 2:10; Ps. 103:13; Jer. 3:19; Hos. 11:3). But in a more important theological sense, God is Father of those who derive their sonship from Christ, and thus share it.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("In "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Central Message of the New Testament")]), _vm._v(" Jeremias argued that this term signified utter trust and intimacy, to such an extent that most Jews would have thought it irreverent to use it. He writes, “It was something new, something unique and unheard of, that Jesus dared . . . to speak with God as a child speaks . . . simply, intimately, securely.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-041-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-041"
    }
  }, [_vm._v("27")])])]), _vm._v(" Unfortunately, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor334"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor335"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor336"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor337"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor338"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor339"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor340"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor341"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor342"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor343"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor344"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor345"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor346"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor347"
    }
  }), _vm._v("perhaps, counterexamples to Jeremias’s argument have been found. But Dunn and many others insist that his argument remains largely true, even if with much less exaggeration. Similarly Dunn links this with Jesus’ experience of the Holy Spirit."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-040-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-040"
    }
  }, [_vm._v("28")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(9) The first three Gospels anticipate Acts in stressing the guidance of the Holy Spirit in moments of crisis. A classic example occurs in Mark 13:11. Here the disciples are warned about times of trial concerning which Jesus urges, “Do not worry beforehand about what you are to say; but say whatever is given you at that time, for it is not you who speak, but the Holy Spirit.” R. T. France warns us that this is not an encouragement for “lazy preachers.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-039-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-039"
    }
  }, [_vm._v("29")])])]), _vm._v(" Henry Swete comments, “It guarantees to Christian confessors, in the moment of need, the presence of an Advocate within.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-038-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-038"
    }
  }, [_vm._v("30")])])]), _vm._v(" On the promise for the future, we may offer a last quotation from Levison. He writes, “This is not a vague promise of joyful inspiration . . . it is rather a promise to a desperate, persecuted, and betrayed people who stand before governors and kings in the service of the gospel.”"), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-037-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-037"
    }
  }, [_vm._v("31")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(10) Luke writes that the Holy Spirit may be received as the result of prayer: “The Father will give the Holy Spirit to those who ask him” (Luke 11:13). We may note that praying for the Spirit is still primarily addressed to God as Father. The context is that of persistence in prayer. The partial parallel in Matt. 7:7-11 stresses the generous Fatherhood of God. In connection with the gift of the Spirit to the disciples, Luke records the “exultation” of Jesus in the Spirit (as Turner calls it) in Luke 10:21."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-036-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-036"
    }
  }, [_vm._v("32")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("(11) As we might expect, Matthew and Luke include sayings relating to the Holy Spirit after the Resurrection of Jesus. Matt. 28:19 recalls the Great Commission, “Make disciples of all nations, baptizing them in the name of the Father and of the Son and of the Holy Spirit.” Many scholars consider that this saying comes only from later reflection or revelation about the Spirit. One strong argument is that Jesus would not have invoked the name of the Trinity. But "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Didachē ")]), _vm._v("7:1 and 3 urges baptism “in the name of the Father, and of the Son, and of the Holy Spirit,” possibly before "), _c('a', {
    attrs: {
      "id": "_idTextAnchor348"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor349"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor350"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor351"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor352"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor353"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor354"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor355"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor356"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor357"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor358"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor359"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor360"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor361"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor362"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor363"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor364"
    }
  }), _vm._v("the end of the first century."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-035-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-035"
    }
  }, [_vm._v("33")])])]), _vm._v(" This may reflect very early tradition. Arthur Wainwright supports this view."), _c('span', {
    staticClass: "noteref _idGenCharOverride-1"
  }, [_c('span', {
    attrs: {
      "id": "footnote-034-backlink"
    }
  }, [_c('a', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-034"
    }
  }, [_vm._v("34")])])])]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("The saying of Jesus in Luke is more indirect. In Luke 24:49, Jesus says, “I am sending upon you what my Father promised . . . you [will] have been clothed with power from on high.” Most writers understand this as a promise of the gift of the Holy Spirit, as fulfilled at Pentecost.")]), _vm._v(" "), _c('p', {
    staticClass: "BODY"
  }, [_vm._v("Other uses of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("spirit")]), _vm._v(" in the first three (or synoptic) gospels usually refer either to the psychological spirit within a person, or to demonic or “supernatural” beings. These are not relevant to teaching or theology about the Holy Spirit of God.")]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnotes"
  }, [_c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-067"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-067-backlink"
    }
  }, [_vm._v("1")]), _vm._v(". John D. Zizioulas, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Being as Communion")]), _vm._v(" (New York: St. Vladimir’s Seminary Press, 1997), pp. 107, 110-11, 129.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-066"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-066-backlink"
    }
  }, [_vm._v("2")]), _vm._v(". Eugene F. Rogers, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("After the Spirit: A Constructive Pneumatology")]), _vm._v(" (London: SCM / Grand Rapids: Eerdmans, 2006), pp. 136-63, here pp. 136-37.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-065"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-065-backlink"
    }
  }, [_vm._v("3")]), _vm._v(". Jürgen Moltmann, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Trinity and the Kingdom of God")]), _vm._v(" (London: SCM, 1981), p. 72.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-064"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-064-backlink"
    }
  }, [_vm._v("4")]), _vm._v(". Keith Warrington, “The Synoptic Gospels,” in Trevor J. Burke and Keith Warrington, eds"), _c('em', {
    staticClass: "italic"
  }, [_vm._v(".")]), _vm._v(","), _c('em', {
    staticClass: "italic"
  }, [_vm._v(" A Biblical")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Theology of the Holy Spirit")]), _vm._v(" (London: SPCK, 2014), pp. 84-103, here p. 95.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-063"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-063-backlink"
    }
  }, [_vm._v("5")]), _vm._v(". Michael Welker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God the Spirit")]), _vm._v(" (Minneapolis: Fortress, 1994), p. 189.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-062"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-062-backlink"
    }
  }, [_vm._v("6")]), _vm._v(". Craig S. Keener, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Spirit in the Gospels and Acts: Divine Purity and Power")]), _vm._v(" (Grand Rapids: Baker Academic, 1997), pp. 102-3.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-061"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-061-backlink"
    }
  }, [_vm._v("7")]), _vm._v(". George Smeaton, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Doctrine of the Holy Spirit")]), _vm._v(" (London: Banner of Truth, 1958 [1882]), pp. 118-20 (my italics).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-060"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-060-backlink"
    }
  }, [_vm._v("8")]), _vm._v(". Max Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power from on High: The Spirit in Israel’s Restoration and Witness in Luke–Acts")]), _vm._v(" (Sheffield: Sheffield Academic Press, 2000),"), _c('em', {
    staticClass: "italic"
  }), _vm._v("p. 47.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-059"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-059-backlink"
    }
  }, [_vm._v("9")]), _vm._v(". Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power from on High, ")]), _vm._v("p. 199.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-058"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-058-backlink"
    }
  }, [_vm._v("10")]), _vm._v(". Ulrich Luz, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Matthew 1–7: A Commentary")]), _vm._v(" (Edinburgh: "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("T&T")]), _vm._v(" Clark, 1990), p. 120.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-057"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-057-backlink"
    }
  }, [_vm._v("11")]), _vm._v(". Welker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God the Spirit, ")]), _vm._v("p. 190.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-056"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-056-backlink"
    }
  }, [_vm._v("12")]), _vm._v(". Welker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God the Spirit, ")]), _vm._v("p. 187 (his italics).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-055"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-055-backlink"
    }
  }, [_vm._v("13")]), _vm._v(". J. A. T. Robinson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Human Face of God")]), _vm._v(" (London: SCM, 1973).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-054"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-054-backlink"
    }
  }, [_vm._v("14")]), _vm._v(". B. F. Westcott, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistle to the Hebrews: The Greek Text")]), _vm._v(" (New York: Macmillan, 1903), on 4:15.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-053"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-053-backlink"
    }
  }, [_vm._v("15")]), _vm._v(". Geoffrey W. H. Lampe, “The Holy Spirit in the Writings of St. Luke,” in D. E. Nineham, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Studies in the")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Gospels")]), _vm._v(" (Oxford: Blackwell, 1967), pp. 159-200, here p. 171.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-052"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-052-backlink"
    }
  }, [_vm._v("16")]), _vm._v(". John R. Levison, “The Holy Spirit in the Gospels,” in Johnson T. K. Lim, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Holy Spirit: Unfinished Agenda")]), _vm._v(" (Singapore: Armour, 2015), pp. 52-56, here p. 53.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-051"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-051-backlink"
    }
  }, [_vm._v("17")]), _vm._v(". Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power from on High, ")]), _vm._v("pp. 231 and 244-50.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-050"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-050-backlink"
    }
  }, [_vm._v("18")]), _vm._v(". Welker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God the Spirit, ")]), _vm._v("p. 202.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-049"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-049-backlink"
    }
  }, [_vm._v("19")]), _vm._v(". James D. G. Dunn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus and the Spirit: A Study of the Religious and Charismatic Experience of Jesus and")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the First Christians as Reflected in the New Testament")]), _vm._v(" (London: SCM, 1975), p. 68.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-048"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-048-backlink"
    }
  }, [_vm._v("20")]), _vm._v(". Dunn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus and the Spirit, ")]), _vm._v("pp. 54, 68-92.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-047"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-047-backlink"
    }
  }, [_vm._v("21")]), _vm._v(". Roger Stronstad, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Charismatic Theology of Saint Luke")]), _vm._v(" (Peabody, MA: Hendrickson, 1984); idem, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Prophethood of All Believers: A Study in Luke’s Charismatic Theology")]), _vm._v(" (Sheffield: Sheffield Academic Press, 1999), pp. 18-27 and elsewhere.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-046"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-046-backlink"
    }
  }, [_vm._v("22")]), _vm._v(". C. K. Barrett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Holy Spirit and the Gospel Tradition")]), _vm._v(" (London: SPCK, 1947), p. 158 (my italics).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-045"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-045-backlink"
    }
  }, [_vm._v("23")]), _vm._v(". J. E. Fison, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Blessing of the Holy Spirit")]), _vm._v(" (London: Longmans, Green, 1950), pp. 11, 22, 72, 93, 107-8, 138-40, 199-200.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-044"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-044-backlink"
    }
  }, [_vm._v("24")]), _vm._v(". Welker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God the Spirit, ")]), _vm._v("p. 190.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-043"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-043-backlink"
    }
  }, [_vm._v("25")]), _vm._v(". Doctrine Commission of the Church of England, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We Believe in the Holy Spirit")]), _vm._v(" (London: Church House Publishing, 1991), p. 184.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-042"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-042-backlink"
    }
  }, [_vm._v("26")]), _vm._v(". Welker, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("God the Spirit, ")]), _vm._v("pp. 213-14.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-041"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-041-backlink"
    }
  }, [_vm._v("27")]), _vm._v(". Joachim Jeremias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Central Message of the New Testament")]), _vm._v(" (London: SCM, 1965), p. 21.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-040"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-040-backlink"
    }
  }, [_vm._v("28")]), _vm._v(". Dunn, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jesus and the Spirit, ")]), _vm._v("pp. 62-66; and Joachim Jeremias, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Testament Theology, ")]), _vm._v("vol. 1 (London: SCM, 1971), pp. 61-68.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-039"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-039-backlink"
    }
  }, [_vm._v("29")]), _vm._v(". Richard T. France, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Gospel of Mark: A Commentary on the Greek Text")]), _vm._v(" (Grand Rapids: Eerdmans, 2002), p. 517.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-038"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-038-backlink"
    }
  }, [_vm._v("30")]), _vm._v(". Henry B. Swete, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Holy Spirit in the New Testament")]), _vm._v(" (London: Macmillan, 1921), p. 122.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-037"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-037-backlink"
    }
  }, [_vm._v("31")]), _vm._v(". John R. Levison, “The Holy Spirit in the Gospels,” p. 55.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-036"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-036-backlink"
    }
  }, [_vm._v("32")]), _vm._v(". Turner, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Power from on High, ")]), _vm._v("p. 264.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-035"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-035-backlink"
    }
  }, [_vm._v("33")]), _vm._v(". K. Lake, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Apostolic Fathers")]), _vm._v(" (Greek and English; Cambridge, MA: Heinemann, 1912), pp. 318-21.")])]), _vm._v(" "), _c('div', {
    staticClass: "_idFootnote",
    attrs: {
      "id": "footnote-034"
    }
  }, [_c('p', {
    staticClass: "FN"
  }, [_c('a', {
    staticClass: "_idFootnoteAnchor _idGenColorInherit",
    attrs: {
      "href": "#/Thiselton_A_Shorter_Guide8#footnote-034-backlink"
    }
  }, [_vm._v("34")]), _vm._v(". Arthur Wainwright, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Trinity in the New Testament")]), _vm._v(" (London: SPCK, 1962), pp. 238-41.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56bf6e1b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Thiselton_A_Shorter_Guide-8.vue
// module id = 78
// module chunks = 0